import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let phone = useDataValue({
    context: 'phone',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    if (phone.communication_preferences) {
      return [
        ...data,
        {
          id: 'SEND_NEXT_APPOINTMENT_REMINDER',
          text: 'Send next appointment reminder',
        },
      ]
    }
    return data
  }, [data])
}
